import React, { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers } from "@shared";
import { useSpinnerContext } from '@contexts';
import { sunboundPayProxy } from '@proxies';

const AutoPayWarning = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { setSpinnerShow } = useSpinnerContext();

    const {
        state: {
            account: {
                idAccount,
                accountPreferences: { dueDay }
            }
        }
    } = location;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const save = async () => {
        setSpinnerShow(true);
        try {
            await sunboundPayProxy.updateAccountPayorPreferences(idAccount, { isAutoPay: true, dueDay });
            helpers.navigateNext(location, navigate, { makePayment: true });
        } catch (error) {
            console.error(error);
        } finally {
            setSpinnerShow(false);
        }
    };
    return (
        <div className="flex flex-col bg-white items-center w-full p-5 gap-y-6 min-h-sb">
            <h1 className="text-center font-bold text-2xl">Turn On Auto-Pay</h1>

            <div className="flex flex-col items-left p-5 rounded-lg border-2 shadow-md gap-y-4 bg-sb-frame w-11/12">
                <p>
                    <span className="text-red-500 font-bold">Payment Required:</span> Because the auto draw day has already passed, you will have to make a manual payment this month.
                </p>
                <p>
                    By clicking <b>Save Changes</b> you are authorizing Sunbound to debit your account for your total monthly balance on the <b>{helpers.dayOrdinal(dueDay)}</b> of each month when an payment is due.
                </p>
                <div className="mt-6">
                    <button className="btn btn-primary font-bold rounded-full" onClick={save}>Save Changes</button>
                </div>
            </div>
        </div>
    );
};

export default AutoPayWarning;